export default __webpack_public_path__ + "static/media/0_6_BEXEN_Cardio_Vertic.aa08b94d.png";